import Footer from 'components/Footers/Footer'
import Navbar from 'components/Navbars/AuthNavbar'
import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import Swal from 'sweetalert2'
import BASE_URL from 'components/BaseUrl/apiConfig'
import { compressAndUploadImage } from 'components/CommanMethod/Commanmethod'
import { useRef } from 'react'

const UpdateProfile = () => {
    const history = useHistory();

    const storedUserData = localStorage.getItem('userData');
    let userId = '';

    if (storedUserData) {
        const userData = JSON.parse(storedUserData);
        userId = userData.userId;
    }

    const BackToUserDetails = () => {
        history.push('/profile');
    }

    const [formData, setFormData] = useState({
        Name: '',
        fullname: '',
        contactNumber: '',
        Email: '',
        profileImage: '',
        profileImagePreview: '', // Add a property for image preview
    });

    const [validationMessages, setValidationErrors] = useState({
        fullname: '',
        contactNumber: ''
    });


    const inputboxfocus= useRef(null);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'profileImage') {
            setFormData((prevData) => ({
                ...prevData,
                [name]: files[0],
                profileImagePreview: URL.createObjectURL(files[0]),
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
        setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '', // Clear the validation error when the user types
        }));
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        // Perform validation logic for each field
        if (formData.fullname.trim() === '') {
            newErrors.fullname = 'Full name is required.';
            isValid = false;
        }

        if (formData.contactNumber.trim() === '') {
            newErrors.contactNumber = 'Contact number is required.';
            isValid = false;
        }

        const allowedExtensions = ['jpeg', 'jpg', 'png'];
        const profileImageExtension = formData.profileImage.name.split('.').pop().toLowerCase();
    
        if (!formData.profileImage.name) {
            newErrors.profileImage = 'Image is required.';
            isValid = false;
        } else if (!allowedExtensions.includes(profileImageExtension)) {
            newErrors.profileImage = 'Only .jpeg, .jpg, or .png files are allowed.';
            isValid = false;
        }

        setValidationErrors(newErrors);
        return isValid;
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        handleCreateAccount();
    };

    const handleCreateAccount = async () => {
        // Validate the form before making the API call
        if (!validateForm()) {
            return;
        }



        try {


            let compressedImage;
            if (formData.profileImage) {
                // Compress the image before uploading
                compressedImage = await compressAndUploadImage(formData.profileImage);
            }


            const formDataForApi = new FormData();
            formDataForApi.append("userId", userId);
            formDataForApi.append("fullname", formData.fullname);
            formDataForApi.append("contact", formData.contactNumber);
            // formDataForApi.append("profileImage", formData.profileImage);
            formDataForApi.append("profileImage", compressedImage || formData.profileImage); // Use the compressed image if available
            formDataForApi.append("imagePath", formData.imagePath);


            const response = await fetch(`${BASE_URL}/api/Users/UpdateUserProfile`, {
                method: 'POST',
                body: formDataForApi,
            });

            if (response.ok) {
                const data = await response.json();

                setFormData({
                    fullname: '',
                    contactNumber: '',
                    profileImage: '',
                    profileImagePreview: null,
                });

                // Display SweetAlert success message
                Swal.fire({
                    icon: 'success',
                    title: 'Successful!',
                    text: 'Profile updated successfully.',
                });

                history.push('/profile')
            } else {
                const errorData = await response.json();
                // Handle error scenarios

                Swal.fire({
                    icon: 'error',
                    title: 'Failed!',
                    text: 'Profile update failed.',
                });
            }
        } catch (error) {
            console.error('Error updating profile:', error.message);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: (error.message),
            });
        }
    };

    useEffect(() => {

        inputboxfocus.current.focus();

        const fetchUserData = async () => {
            try {
                const response = await fetch(
                    `${BASE_URL}/api/Users/GetUserById?userId=${userId}`
                );

                if (response.ok) {
                    const userData = await response.json();

                    // Update the form data with the retrieved user data
                    setFormData({
                        fullname: userData.fullName,
                        contactNumber: userData.contact,
                        profileImagePreview: userData.image,
                        image: userData.image,
                        imagePath: userData.imagePath,
                        Name: userData.userName,
                        Email: userData.emailId,

                        //image:userData.
                        // Add more properties if needed
                        // profileImagePreview: userData.profileImage
                        //     ? BASE_URL + userData.profileImage // Assuming the API returns a relative path
                        //     : null,
                    });
                } else {
                    // Handle error scenarios
                    console.error('Failed to fetch user data:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching user data:', error.message);
            }
        };

        fetchUserData();
    }, [userId]);


    return (
        <>
            <Navbar />
            <div className='cust-div'>
                <div className="container mx-auto p-4 h-full">
                    <div className="flex content-center items-center justify-center h-full">
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                                <div className="rounded-t mb-0 px-6 py-3">
                                    <div className="text-center mb-3">
                                        <h6 className="text-blueGray-800 text-sm text-3xl font-bold">
                                            Update Your Profile
                                        </h6>
                                    </div>
                                    {/* <hr className="mt-3 border-b-1 border-blueGray-300" /> */}

                                    <div className="flex flex-wrap">
                                        <div className="w-full lg:flex">
                                            <div className="lg:w-1/2">
                                                <label className="uppercase text-blueGray-600 text-xs font-bold mb-2  lg:mb-0">User Name : </label>
                                                <span className="ml-1">{formData.Name}</span>
                                            </div>
                                            <div className="lg:w-1/2  lg:mt-0">
                                                <label className="uppercase text-blueGray-600 text-xs font-bold mb-2 ml-3 lg:mb-0">Email : </label>
                                                <span className="ml-1">{formData.Email}</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                                    <form onSubmit={handleFormSubmit}>
                                        {/* FullName Input */}
                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="fullname"
                                            >
                                                Full Name
                                            </label>
                                            <input
                                                type="text"
                                                id="fullname"
                                                name="fullname"
                                                ref={inputboxfocus}
                                                value={formData.fullname}
                                                onChange={handleChange}
                                                className="border rounded w-full"
                                                placeholder="Full Name"
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.fullname}
                                            </div>
                                        </div>

                                        {/* UserName Input */}
                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="contactNumber"
                                            >
                                                Contact Number
                                            </label>
                                            <input
                                                type="text"
                                                id="contactNumber"
                                                name="contactNumber"
                                                value={formData.contactNumber}
                                                onChange={handleChange}
                                                className="border rounded w-full"
                                                placeholder="Contact Number"
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.contactNumber}
                                            </div>
                                        </div>

                                        {/* profile Image Input */}
                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="profileImage"
                                            >
                                                Profile Image
                                            </label>
                                            <input
                                                type="file"
                                                id="profileImage"
                                                name="profileImage"
                                                onChange={handleChange}
                                                className="border px-3 py-2 w-full"
                                                placeholder="Profile Image"
                                            />

                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.profileImage}
                                            </div>

                                            <input type="hidden" id="image" name="image" value={formData.imagePath}>
                                            </input>


                                        </div>

                                        <div className="flex items-center justify-between mt-6">

                                            <div className='justify-start'>
                                                {/* Image Preview */}
                                                {formData.profileImagePreview && (
                                                    <img
                                                        src={formData.profileImagePreview}
                                                        alt="Profile Preview"
                                                        className="max-w-full h-auto mt-2"
                                                        style={{ width: '150px', height: '150px' }}  // Adjust the values as needed
                                                    />
                                                )}
                                            </div>

                                            {/* Buttons */}
                                            <div className="flex  justify-end space-x-4">
                                                <button
                                                    type="button"
                                                    className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 mr-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                                                    onClick={BackToUserDetails}
                                                >
                                                    Back to User Details
                                                </button>
                                                <button
                                                    className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-3 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none sm:w-auto ease-linear transition-all duration-150"
                                                    type="submit"
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>

                                    </form>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default UpdateProfile;
